export const stripHtmlTags = (html: string): string =>
  html.replace(/<[^>]*>/g, "").trim()

export const hasRichTextContent = (
  node:
    | Storyblok.StoryblokRichtextContent
    | Storyblok.RichTextBlockStructure
    | Storyblok.RichTextBlock
    | string
    | undefined
): boolean => {
  if (typeof node === "string") {
    // For string type, check if it is not an empty string
    return node.trim().length > 0
  }

  if (!node) {
    return false
  }

  // Look for empty nodes
  if (
    "text" in node &&
    node.text !== undefined &&
    node.text.trim().length > 0
  ) {
    return true
  }

  if ("content" in node && Array.isArray(node.content)) {
    // Check if array contains content
    return node.content.some((contentNode) =>
      hasRichTextContent(
        contentNode as
          | Storyblok.StoryblokRichtextContent
          | Storyblok.RichTextBlockStructure
      )
    )
  }

  return false
}
